import { createActionGroup, emptyProps } from '@ngrx/store';

export const RoutingFactoryActions = createActionGroup({
  source: 'Routing Factory',
  events: {
    Enter: emptyProps(),
  },
});
